import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../components/helper";

export const getFavouriteSetting = createAsyncThunk(
  "favourite/getFavouriteSetting",
  async (accountCode) => {
    const response = await http.get(
      `favourite/favouriteSetting/${accountCode}`
    );
    return response.data;
  }
);

export const createOrUpdateFavouriteSetting = createAsyncThunk(
  "vendor/createOrUpdateFavouriteSetting",
  async (body, { rejectWithValue }) => {
    try {
      // flatten data so backend receives fields at root
      const payload = {
        ...body,
      };
      const response = await http.post("favourite/update-setting", payload);
      return [response.data.data];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getFavourites = createAsyncThunk(
  "favourite/getFavourites",
  async (accountCode) => {
    const response = await http.get(`favourite/favourites/${accountCode}`);
    return response.data;
  }
);

export const createFavouriteFolder = createAsyncThunk(
  "vendor/create-folder",
  async (body, { rejectWithValue }) => {
    try {
      // flatten data so backend receives fields at root
      const payload = {
        ...body,
      };
      const response = await http.post("favourite/create-folder", payload);
      return response.data;
    } catch (error) {
      console.error(
        "Create Favourite Folder Error:",
        error.response?.data || error.message
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addproductstoFavourite = createAsyncThunk(
  "vendor/addproductstoFavourite",
  async (body, { rejectWithValue }) => {
    try {
      // flatten data so backend receives fields at root
      const payload = {
        ...body,
      };
      const response = await http.post(
        "favourite/addproductstoFavourite",
        payload
      );
      return response.data;
    } catch (error) {
      console.error(
        "Create Favourite Folder Error:",
        error.response?.data || error.message
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getFavouriteFolders = createAsyncThunk(
  "favourite/getFavouriteFolders",
  async (accountCode) => {
    const response = await http.get(
      `favourite/favourite-folders/${accountCode}`
    );
    return response.data;
  }
);

export const deleteFavouriteItem = createAsyncThunk(
  "favourite/deleteFavouriteItem",
  async (payload) => {
    const response = await http.post("favourite/deleteFavouriteItem", payload);
    return response.data;
  }
);

export const deleteFavouriteFolder = createAsyncThunk(
  "favourite/deleteFavouriteFolder",
  async (payload) => {
    const response = await http.post("favourite/deleteFavouriteFolder", payload);
    return response.data;
  }
);

export const updateFavouriteItem = createAsyncThunk(
  "favourite/update-favourite",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await http.put(
        `favourite/update-favourite/${payload.id}`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error(
        "Update favourite item:",
        error.response?.data || error.message
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const assignProductToFolders = createAsyncThunk(
  "/favorite/assign-product",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await http.post(
        `/favorite/assign-product`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error(
        "Assign product failed:",
        error.response?.data || error.message
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const bulkFavouriteItemsUpdate = createAsyncThunk(
  "favourite/bulkupdate-favourite",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await http.post(
        `/favourite/bulkupdate-favourite`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error(
        "Update favourite item:",
        error.response?.data || error.message
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateFavouriteFolder = createAsyncThunk(
  "favourite/update-folder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await http.put(
        `favourite/update-folder/${payload.id}`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error(
        "Update favourite Folder:",
        error.response?.data || error.message
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const bulkDeleteFavouriteItems = createAsyncThunk(
  "favourite/bulkRemoveFavouriteItems",
  async (payload) => {
    const response = await http.post("favourite/bulkRemoveFavouriteItems", payload);
    return response.data;
  }
);

const initialState = {
  favoriteSetting: null,
  favouriteList: [],
  settingStatus: "idle",
  listStatus: "idle",
  error: null,
  settingError: null,
  folderError: null,
  folderStatus: "idle",
  favouriteItem: null,
  itemError: null,
  itemStatus: "idle",
  favouriteFolders: [],
  deleteItemStatus: "idle",
  updateItemStatus: "idle",
  deleteFolderStatus:"idle",
  updateFolderStatus:"idle",
  favouriteFolder:null,
  deleteBulkItemStatus:"idle"
};

const favouriteSlice = createSlice({
  name: "favourites",
  initialState,
  reducers: {
    resetFavourites: (state) => {
      state.favoriteSetting = null;
      state.favouriteList = [];
      state.favouriteFolders = [];
      state.favouriteItem = null;

      state.settingStatus = "idle";
      state.listStatus = "idle";
      state.folderStatus = "idle";
      state.itemStatus = "idle";

      state.deleteItemStatus = "idle";
      state.updateItemStatus = "idle";
      state.deleteFolderStatus = "idle";
      state.updateFolderStatus = "idle";
      state.deleteBulkItemStatus = "idle";

      state.error = null;
      state.settingError = null;
      state.folderError = null;
      state.itemError = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFavouriteSetting.pending, (state) => {
        state.settingStatus = "loading";
      })
      .addCase(getFavouriteSetting.fulfilled, (state, action) => {
        state.settingStatus = "succeeded";
        state.favoriteSetting = action.payload?.data || [];
      })
      .addCase(getFavouriteSetting.rejected, (state, action) => {
        state.settingStatus = "failed";
        state.error =
          action.error?.message || "Failed to load Favourite Settings";
      })
      .addCase(createOrUpdateFavouriteSetting.pending, (state) => {
        state.settingStatus = "loading";
        state.settingError = null;
      })
      .addCase(createOrUpdateFavouriteSetting.fulfilled, (state, action) => {
        state.settingStatus = "succeeded";
        state.favoriteSetting = action.payload;
      })
      .addCase(createOrUpdateFavouriteSetting.rejected, (state, action) => {
        state.settingStatus = "failed";
        state.settingError = action.error?.message || "Failed to create lead";
      })

      // Favourites List cases
      .addCase(getFavourites.pending, (state) => {
        state.listStatus = "loading";
      })
      .addCase(getFavourites.fulfilled, (state, action) => {
        state.listStatus = "succeeded";
        state.favouriteList = action.payload?.data || [];
      })
      .addCase(getFavourites.rejected, (state, action) => {
        state.listStatus = "failed";
        state.error = action.error?.message || "Failed to load FAQs";
      })
      .addCase(createFavouriteFolder.pending, (state) => {
        state.folderStatus = "loading";
        state.folderError = null;
      })
      .addCase(createFavouriteFolder.fulfilled, (state, action) => {
        state.folderStatus = "succeeded";
        state.folder = action.payload;
      })
      .addCase(createFavouriteFolder.rejected, (state, action) => {
        state.folderStatus = "failed";
        state.folderError = action.error?.message || "Failed to create lead";
      })
      .addCase(addproductstoFavourite.pending, (state) => {
        state.itemStatus = "loading";
        state.itemError = null;
      })
      .addCase(addproductstoFavourite.fulfilled, (state, action) => {
        state.itemStatus = "succeeded";
        state.favouriteItem = action.payload;
      })
      .addCase(addproductstoFavourite.rejected, (state, action) => {
        state.itemStatus = "failed";
        state.itemError = action.error?.message || "Failed to create lead";
      })

      // Favourites Folder cases
      .addCase(getFavouriteFolders.pending, (state) => {
        state.folderStatus = "loading";
      })
      .addCase(getFavouriteFolders.fulfilled, (state, action) => {
        state.folderStatus = "succeeded";
        state.favouriteFolders = action.payload?.data || [];
      })
      .addCase(getFavouriteFolders.rejected, (state, action) => {
        state.folderStatus = "failed";
        state.error = action.error?.message || "Failed to load FAQs";
      })
      .addCase(deleteFavouriteItem.rejected, (state, action) => {
        state.deleteItemStatus = "failed";
        state.error = action.error.message;
      })
      .addCase(deleteFavouriteItem.pending, (state) => {
        state.deleteItemStatus = "loading";
      })
      .addCase(deleteFavouriteItem.fulfilled, (state) => {
        state.deleteItemStatus = "succeeded";
      })
      .addCase(assignProductToFolders.rejected, (state, action) => {
        state.updateItemStatus = "failed";
        state.error = action.error.message;
      })
      .addCase(assignProductToFolders.pending, (state) => {
        state.updateItemStatus = "loading";
      })
      .addCase(assignProductToFolders.fulfilled, (state, action) => {
        state.updateItemStatus = "succeeded";
        state.favouriteItem = action.payload.data;
      })
      .addCase(bulkFavouriteItemsUpdate.rejected, (state, action) => {
        state.updateItemStatus = "failed";
        state.error = action.error.message;
      })
      .addCase(bulkFavouriteItemsUpdate.pending, (state) => {
        state.updateItemStatus = "loading";
      })
      .addCase(bulkFavouriteItemsUpdate.fulfilled, (state, action) => {
        state.updateItemStatus = "succeeded";
        state.favouriteItem = action.payload.data;
      })
       .addCase(deleteFavouriteFolder.rejected, (state, action) => {
        state.deleteFolderStatus = "failed";
        state.error = action.error.message;
      })
      .addCase(deleteFavouriteFolder.pending, (state) => {
        state.deleteFolderStatus = "loading";
      })
      .addCase(deleteFavouriteFolder.fulfilled, (state) => {
        state.deleteFolderStatus = "succeeded";
      })
       .addCase(updateFavouriteFolder.rejected, (state, action) => {
        state.updateFolderStatus = "failed";
        state.error = action.error.message;
      })
      .addCase(updateFavouriteFolder.pending, (state) => {
        state.updateFolderStatus = "loading";
      })
      .addCase(updateFavouriteFolder.fulfilled, (state, action) => {
        state.updateFolderStatus = "succeeded";
        state.favouriteFolder = action.payload.data;
      })
      .addCase(bulkDeleteFavouriteItems.rejected, (state, action) => {
        state.deleteBulkItemStatus = "failed";
        state.error = action.error.message;
      })
      .addCase(bulkDeleteFavouriteItems.pending, (state) => {
        state.deleteBulkItemStatus = "loading";
      })
      .addCase(bulkDeleteFavouriteItems.fulfilled, (state) => {
        state.deleteBulkItemStatus = "succeeded";
      })
      
  },
});
export const { resetFavourites } = favouriteSlice.actions;
export default favouriteSlice.reducer;
